// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73a7700c","667":"c536a221"}[chunkId] + ".chunk.js";
};